import React from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Y si no puedo soltar?',
    a: 'No es fuerza, es entender el patrón.'
  }, {
    q: '¿Y si recaigo?',
    a: 'Está diseñado para evitarlo.'
  }, {
    q: '¿Es para mí?',
    a: 'Si te viste reflejada, sí.'
  }];
  return <section className="py-8 md:py-10 px-3 md:px-4 bg-black" data-id="element-59">
      <div className="max-w-2xl mx-auto" data-id="element-60">
        <h2 className="text-2xl font-black text-white text-center uppercase mb-6" data-id="element-61">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-62">
          {faqs.map((faq, idx) => <div key={idx} className="bg-dark border border-white/10 p-4 rounded-lg" data-id="element-63">
              <h4 className="text-rosa font-bold mb-1" data-id="element-64">{faq.q}</h4>
              <p className="text-gray-300 text-sm" data-id="element-65">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}